"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
require("./Toggle.scss");
var Toggle = function (props) { return (react_1.default.createElement("div", { className: classnames_1.default('toggle-switch', props.className), onClick: props.onToggle },
    react_1.default.createElement("input", { id: props.id, type: "checkbox", name: props.id, className: classnames_1.default(classnames_1.default('switch', { 'is-success': props.checked, 'is-dark': !props.checked })), checked: props.checked, readOnly: true }),
    react_1.default.createElement("label", null))); };
exports.Toggle = Toggle;
